/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespIconBubbles_item = {
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubblePinterest_item" | "PdpSharedIconBubbleFacebook_item" | "PdpSharedIconBubbleEmail_item">;
    readonly " $refType": "PdpRespIconBubbles_item";
};
export type PdpRespIconBubbles_item$data = PdpRespIconBubbles_item;
export type PdpRespIconBubbles_item$key = {
    readonly " $data"?: PdpRespIconBubbles_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespIconBubbles_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespIconBubbles_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubblePinterest_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleFacebook_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedIconBubbleEmail_item",
      "args": null
    }
  ]
};
(node as any).hash = '728b75da82490d73bad044aac0e7039d';
export default node;
